export default
{
    Complaints: [],
    Complaint: {},
}
